import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as permissionService from "../../services/permission.services";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder } from "rsuite";

const PermissionTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showDefault, setShowDefault] = useState([]);
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const devParam = queryParams.get('dev');
  const showAddButton = devParam === 'true';
  const [isDevMode, setIsDevMode] = useState(showAddButton);

  useEffect(() => {
    setIsDevMode(showAddButton);
  }, [showAddButton]);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_sub_admin"), url: "/admin/staff/list/1" },
    { title: t("label_permission"), url: "" },
  ];

  useEffect(() => {
    permissionService
      .List()
      .then((response) => {
        setShowDefault(response?.data || []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }, []);


  const grouped = showDefault.reduce((acc, permission) => {
    const group = permission.groupName || t("label_others");
    if (!acc[group]) acc[group] = [];
    acc[group].push(permission);
    return acc;
  }, {});

  const groupKeys = Object.keys(grouped);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label text-uppercase">
                {t("label_permission")}
              </h6>
              {/* <button
                type="button"
                className="btn ripple btn-main-primary signbtn"
                onClick={() => navigate("/admin/permission/add")}
              >
                {t("btn_add_new")}
              </button> */}
              {isDevMode  && (
                <button className="btn ripple btn-main-primary signbtn" onClick={() => navigate(`/admin/permission/add?dev=true`)}>Add New</button>
              )}
            </div>

            {loader ? (
              <Placeholder.Paragraph
                className="w-100 admin-placeholder"
                rowHeight={30}
                rowSpacing={5}
                active
                rows={7}
              />
            ) : (
              <div className="permissions-group-list">
                {groupKeys.length === 0 ? (
                  <p className="text-muted mb-0">{t("msg_no_records")}</p>
                ) : (
                  groupKeys.map((groupName) => (
                    <div key={groupName} className="permission-group mb-4">
                      <h6 className="permission-group-title mb-3">
                        {groupName}
                      </h6>
                      <div className="d-flex flex-wrap gap-2">
                        {(grouped[groupName] || []).map((p) => (
                          <span key={p._id} className="permission-pill">
                            {p.title || p.short_slug || p.shortSlug || p._id}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PermissionTable;